import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema4/T4_paneles_teclado_quiz.glb";
import { GUI } from "dat.gui";
import gsap from "gsap";

export class PanelesTecladoQuiz extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.position.set(-11.3, -0.93, -1.9);
		this.rotation.set(1.57, -3.14, -4.7);
		this.scale.set(0.8, 0.8, 1)
		// this.helpers()

	}
	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);
			this.OptionA = gltf.scene.getObjectByName("Option_a", true);
			this.OptionB = gltf.scene.getObjectByName("Option_b", true);
			this.OptionC = gltf.scene.getObjectByName("Option_c", true);
		})
	}
	helpers() {
		const gui = new GUI();
		const escanerFolder = gui.addFolder("Paneles");
		escanerFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		escanerFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		escanerFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		escanerFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		escanerFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		escanerFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		escanerFolder.add(this.scale, "x", -5, 5).step(0.0001).name("scale x");
		escanerFolder.add(this.scale, "y", -5, 5).step(0.0001).name("scale y");
		escanerFolder.add(this.scale, "z", -5, 5).step(0.0001).name("scale z");
		escanerFolder.add(this, "visible").name("visible");
	}
	helpersChild() {
		this.helpersMethod("Option a", this.OptionA);
		this.helpersMethod("Option b", this.OptionB);
		this.helpersMethod("Option c", this.OptionC);
	}


	helpersMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		const limit = 20;
		folferMostrador.add(position, "x", -limit, limit).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limit, limit).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limit, limit).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}
	onRotate(object) {
		this.clearAnimation(object)
		if (!object) {
			return
		}
		this.objectActiveAnimation = object
		object.animation = gsap.to(object.rotation, {
			z: Math.PI * 2,
			duration: 1,
			ease: "power3.out",
		});
	}
	clearAnimation(object) {
		if (object.animation) {
			object.animation.kill();
			object.rotation.z = 0;
		}

		if (this.objectActiveAnimation) {
			this.objectActiveAnimation = null
		}
	}
}